import { ShieldAlert } from "lucide-react";
import { useNavigate } from "react-router-dom";

export const ADULT_CONSENT_KEY = "ipv_adult_ok";
export const TOBACCO_CONSENT_KEY = "ipv_tobacco_ok";
export const hasAdultConsent = () => localStorage.getItem(ADULT_CONSENT_KEY) === "1";
export const hasTobaccoConsent = () => localStorage.getItem(TOBACCO_CONSENT_KEY) === "1";

export const AgeGate = ({ onConfirm, minAge = 18 }) => {
  const nav = useNavigate();
  const key = minAge >= 21 ? TOBACCO_CONSENT_KEY : ADULT_CONSENT_KEY;
  return (
    <div className="fixed inset-0 z-[70] bg-[#0A1C40]/95 flex items-center justify-center p-4" data-testid="age-gate">
      <div className="bg-white max-w-md w-full p-8 text-center rounded-xl">
        <ShieldAlert className="w-10 h-10 mx-auto text-[#C9971E]" />
        <h2 className="font-display font-black text-2xl mt-4 text-[#0A1C40]">
          {minAge >= 21 ? "21 and over only" : "Adults only — 18+"}
        </h2>
        <p className="text-sm text-gray-600 mt-3 leading-relaxed">
          {minAge >= 21
            ? "This department is restricted to customers 21 years of age or older. A government photo ID is checked on every purchase, including at pickup or delivery."
            : "This section contains adult products intended for customers 18 years of age or older. By entering you confirm you are at least 18."}
        </p>
        <div className="grid grid-cols-2 gap-3 mt-6">
          <button
            onClick={() => nav("/")}
            className="border-2 border-gray-300 text-gray-700 font-bold py-3 rounded-full"
            data-testid="age-gate-deny"
          >
            Leave
          </button>
          <button
            onClick={() => {
              localStorage.setItem(key, "1");
              onConfirm();
            }}
            className="bg-[#0A1C40] text-white font-black py-3 rounded-full"
            data-testid="age-gate-confirm"
          >
            I'm {minAge} or older
          </button>
        </div>
      </div>
    </div>
  );
};
